import PropTypes from 'prop-types';
import React from 'react';
import {FormattedMessage} from 'react-intl';

import {ShippingRatesProvider} from '../../../mapi/ShippingRatesProvider';
import {LineItemShipping} from './LineItemShipping';
import {listingFormMessages} from './lineItemMessages';

const ShippingOrRecipientMessage = ({ lineItem }) =>
    lineItem.deliveryMethod === 'PHYSICAL' ? (
        <ShippingRatesProvider>
            <LineItemShipping lineItem={lineItem} />
        </ShippingRatesProvider>
    ) : (
        <div className="line-item-recipient">
            <FormattedMessage
                {...listingFormMessages.emailDelivery}
                values={{
                    name: lineItem.isSelfBuy ? 'You' : lineItem.recipientName
                }}
            />
        </div>
    );

ShippingOrRecipientMessage.propTypes = {
    lineItem: PropTypes.object.isRequired
};

export default ShippingOrRecipientMessage
